import { z } from 'zod';

export const SuggestionTypeEnum = z.enum([
    'if-then',
    'screener',
    'scanner',
    'formula',
    'watchlist',
    'universe',
    'account',
    'workspace',
]);
export type SuggestionType = z.infer<typeof SuggestionTypeEnum>;

export const SuggestionSchema = z.object({
    type: SuggestionTypeEnum,
    id: z.string(),
});

export type Suggestion = z.infer<typeof SuggestionSchema>;

export const StoredSuggestionSchema = z.object({
    id: z.string(),
    userId: z.string(),
    // TODO: Check z.number().nullable()
    accessedAt: z.union([z.number(), z.null()]),
    createdAt: z.union([z.number(), z.null()]),
});

export type StoredSuggestion = z.infer<typeof StoredSuggestionSchema>;

export const NewSuggestionsSchema = z.object({
    version: z.literal(1),
    userId: z.string(),
    byType: z.partialRecord(SuggestionTypeEnum, z.array(StoredSuggestionSchema)),
});

export type NewSuggestionsStorage = z.infer<typeof NewSuggestionsSchema>;

// Legacy schema for backwards compatibility
export const LegacySuggestionsSchema = z.object({
    recentlyAccessed: z.array(SuggestionSchema),
    recentlyCreated: z.array(SuggestionSchema),
});

export type LegacySuggestionsStorage = z.infer<typeof LegacySuggestionsSchema>;

export interface SuggestionsService {
    addRecentlyAccessed(newItem: Suggestion): void;
    addRecentlyCreated(newItem: Suggestion): void;
    delete(id: string): void;
    getItems(opts: { types?: SuggestionType[]; query: 'accessedAt' | 'createdAt'; limit?: number }): Suggestion[];
}
